<div
  class="wk-modal wk-modal-opened"
  aria-hidden="false"
  *ngIf="showContent"
  hasOverlayClickClose="true"
>
  <div class="wk-modal-content">
    <header class="wk-modal-header">
      <div class="wk-modal-title" tabindex="-1">{{title | translate}}</div>
      <button
        type="button"
        class="wk-modal-close wk-button wk-button-icon wk-button-close"
        (click)="closeDialog()"
        (keyup.enter)="closeDialog()"
      >
        <span class="wk-icon-filled-close" aria-hidden="true"></span
        ><span class="wk-sr-only">Close</span>
      </button>
    </header>
    <div class="wk-modal-body">
      <p slot="body">{{message | translate}}</p>
    </div>
    <footer class="wk-modal-footer">
      <div class="wk-button-group wk-button-group-right">
        <button
          type="button"
          class="wk-button wk-button-text"
          (click)="closeDialog()"
          (keyup.enter)="closeDialog()"
        >
          {{noLabel | translate}}
        </button>
        <button
          type="button"
          [ngClass]="yesButtonClass"
          (click)="stayProcess()"
        >
          {{yesLabel | translate}}
        </button>
      </div>
    </footer>
  </div>
</div>
